import React from "react";
import InvoiceForm from "./pages/invoiceform";
import { Route, Routes } from "react-router-dom";
import MathuraInfratec from "./pages/Companies/mathurainfratec";
import MathuraInfrastructure from "./pages/Companies/mathuraInfrastructure";
import Qctech from "./pages/Companies/qctech";
import Shubavarna from "./pages/Companies/shubvarna";
import QuoteInfrastructure from "./pages/Companies/Quotation/MIS";
import Payslip from "./pages/Companies/payslip";
import Payslipdisplay from "./pages/Companies/payslipdisplay";

const App = () => {
  return (
    <>
      <Routes>
        {/* <Route path="/mathura" element={<InvoiceForm />}></Route/> */}
        <Route path="/invoice" element={<InvoiceForm />} />
        <Route path="/imis" element={<MathuraInfrastructure />} />
        <Route path="/qmis" element={<QuoteInfrastructure />} />
        <Route path="/minfratec" element={<MathuraInfratec />} />
        <Route path="/qctech" element={<Qctech />} />
        <Route path="/shubavarna" element={<Shubavarna />} />
        <Route path="/payslip" element={<Payslip />} />
        {/* <Route path="/pay1" element={<Payslipdisplay />} /> */}
      </Routes>
    </>
  );
};

export default App;
